<template>
  <div>
    <b-navbar toggleable="lg" fixed="top" class="custom-header px-lg-5">
      <b-navbar-brand @click="$router.push({ path: `/` })" role="button">
        <img class="main-logo" src="@/assets/imgs/main-logo.svg" width="72px" />
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto" v-if="

          $route.name !== 'ThaneFranchise' &&
          $route.name !== 'GujratFranchise' &&
          $route.name !== 'MiraRoadFranchise' &&
          $route.name !== 'LowerParelFranchise' &&
          $route.name !== 'RaipurFranchise' &&
          $route.name !== 'SolapurFranchise' &&
          $route.name !== 'NaviMumbaiFranchise' &&
          $route.name !== 'KarnatakaFranchise' &&
          $route.name !== 'DubaiFranchise' &&
          $route.name !== 'KuwaitFranchise' &&
          $route.name !== 'DeccanFranchise' &&
          $route.name !== 'KarveRoadFranchise' &&
          $route.name !== 'PimpleFranchise' &&
          $route.name !== 'CoimbatoreFranchise' &&
          $route.name !== 'OMRChennaiFranchise'">
          <b-nav-item @click="redirectTo('/search/search')" class="menu-item">
            <!-- Search -->
            Finder
          </b-nav-item>
          <b-nav-item-dropdown id="dropdown-1" text="Country" right>
            <b-dropdown-item v-for="(country, index) in getCountries" :key="'country ' + index"
              class="dropdown-custom-item" @click="(e) =>
                $router.push({
                  name: 'CountryAbout',
                  params: { country_key: country.country_key },
                })
                ">
              {{ country.country_name }}
              <!-- <div class="light-text">Text Text</div> -->
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown id="dropdown-1" text="Services">
            <b-dropdown-item class="dropdown-custom-item" @click="redirectTo('/abroad-counselling')">
              Study Abroad Counselling

              <!-- <div class="light-text">Text Text</div> -->
            </b-dropdown-item>
            <b-dropdown-item class="dropdown-custom-item" @click="redirectTo('/ielts')">
              IELTS Coaching

              <!-- <div class="light-text">Text Text</div> -->
            </b-dropdown-item>
            <b-dropdown-item class="dropdown-custom-item" @click="redirectTo('/career-counselling')">
              Career Counselling
              <!-- <div class="light-text">Text Text</div> -->
            </b-dropdown-item>

            <!-- <b-dropdown-item
              class="dropdown-custom-item"
              @click="redirectTo('/edgeout')"
            >
              Edge Out

            </b-dropdown-item> -->
            <b-dropdown-item class="dropdown-custom-item" @click="redirectTo('/aliff-premium')">
              Aliff Premium Packages
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item class="menu-item" @click="redirectTo('/about-us')">
            About us
          </b-nav-item>
          <b-nav-item-dropdown id="dropdown-1" text="Resources">
            <!-- <b-dropdown-item
              class="dropdown-custom-item"
              @click="() => $router.push({ path: '/blog/foreign-education-consultants-the-steppingstone-to-successfully-studying-abroad/' })"
            > -->
            <!-- new -->
            <!-- <b-dropdown-item
              class="dropdown-custom-item"
              @click="redirectTo('/accomodations')"
            >
              Accomodations
            </b-dropdown-item> -->
            <!-- new -->
            <b-dropdown-item class="dropdown-custom-item" @click="() =>
              $router.push({
                path: `/blogs/${getBlogs[0].id}/${getBlogs[0].attributes.seo_url}`,
              })
              ">
              Aliff Blogs
            </b-dropdown-item>
            <b-dropdown-item class="dropdown-custom-item" @click="redirectTo('/tv-screen')">
              Aliff TV
            </b-dropdown-item>
            <!-- <b-dropdown-item class="dropdown-custom-item"
                @click="() => $router.push({ path: '/sef' })"
              > -->
            <b-dropdown-item class="dropdown-custom-item" @click="redirectTo('/sef')">
              Student Enquiry Form
            </b-dropdown-item>
            <b-dropdown-item class="dropdown-custom-item" @click="redirectTo('/fair')">
              Study Abroad Fair
            </b-dropdown-item>
            <b-dropdown-item class="dropdown-custom-item" @click="redirectTo('/franchise-page')">
              Aliff Franchise Form
            </b-dropdown-item>
            <b-dropdown-item class="dropdown-custom-item" @click="redirectTo('/associate-page')">
              Aliff Associate Form
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <!-- <b-nav-item
            class="menu-item"
            @click="() => $router.push({ path: '/contact-us' })"
            >Connect
          </b-nav-item> -->

          <b-nav-item :href="DASHBOARD_LOGIN_URL" class="menu-item login-text"
            target="blank"><span>Login</span></b-nav-item>
          <!-- :href="DASHBOARD_REGISTER_URL" -->

          <!--  <b-nav-item
            @click="() => $router.push({ path: '/franchise-locator' })"
            target="blank"
            role="button"
            class="menu-item register-btn"
            >Register</b-nav-item
          > -->
          <b-nav-item @click="() => $router.push({ path: '/office-locator' })" class="menu-item register-btn">Office
            Locator</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div v-if="false">
      <button id="feedback-button" v-b-popover.hover="''" class="float_left" v-b-modal.feedback-form-call-modal-id>
        <!-- <i class="bi bi-chat-fill"></i> -->
        <img src="../../assets/imgs/customer-service-agent_3829427.png" alt="admin" width="30" class="rounded-cirlce" />
      </button>

      <b-popover id="custom-popover-content" target="feedback-button" triggers="hover" placement="top" class="bg-dark">
        <div class="d-flex align-items-center">
          <!-- <h4>Book Free Counselling</h4> -->
          <div class="text-new p-3 text-start text-light">
            <h2 class="font-weight-bold">Hi there!</h2>
            <!-- <p class="">We Are here to Help!</p> -->
            <button class="pop-btn rounded-pill">Give Us Your Feedback</button>
          </div>
        </div>
      </b-popover>

      <!-- <b-modal
        id="feedback-form-call-modal-id"
        ref="feedback-form-call-modal-ref"
        centered
        cancel-disabled
        ok-disabled
        :hide-footer="true"
      >
        <div slot="modal-title">
          <img
            title="my-img"
            src="@/assets/imgs/student-enquiry-form/AliffLogo.png"
            alt="people"
            class="free-counselling-logo"
          />
          FeedBack Form
        </div>

        <form ref="form" @submit.prevent="handleSubmit">
          <div class="custom-form-control">
            <div class="form-spacing">
              <label>Who Are You ?</label>
              <b-form-radio-group
                @change="onSelectIam"
                :options="['Student', 'Franchise', 'University', 'Associates']"
                name="i_am"
                id="i_am_id"
                button-variant="outline-primary"
                buttons
              >
              </b-form-radio-group>
            </div>

            <div class="form-spacing">
              <label>Name:</label>
              <input
                size="sm"
                required
                v-model="form.name"
                placeholder="Enter Name *"
                class="form-control"
              />
            </div>

            <div class="form-spacing">
              <label>Email:</label>
              <input
                required
                size="sm"
                v-model="form.email"
                placeholder="Enter Email Address *"
                class="form-control"
              />
            </div>

            <div class="form-spacing">
              <label>Phone Number:</label>
              <input
                required
                size="sm"
                v-model="form.mobileNumber"
                placeholder="Enter Mobile Number *"
                class="form-control"
              />
            </div>
            <div class="form-spacing">
              <label>Message:</label>
              <b-form-textarea
                id="textarea"
                v-model="form.messageData"
                placeholder="Write To Us"
                rows="3"
                max-rows="6"
                required
              ></b-form-textarea>

            </div>
            <p class="mb-0 font-weight-bold">
              For Further Queries.Write Us at
              <a href="mailto:ceo@aliff.in">ceo@aliff.in</a>
            </p>
            <div class="w-100 pt-4 d-flex justify-content-start">
              <button
                type="submit"
                class="btn rounded w-50"
                style="background-color: #fe6d01; color: white"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </b-modal> -->

      <b-modal id="book-counselling-modal-id" ref="book-counselling-modal-ref" centered title="Book Free Counselling"
        cancel-disabled ok-disabled :hide-footer="true">
        <vue-calendly :height="600" url="https://calendly.com/info-aliff-39025">
        </vue-calendly>
      </b-modal>
    </div>

    <div>
      <button id="counseling-button" v-b-popover.hover="''" class="float" v-b-modal.book-counselling-call-modal-id>
        <!-- <i class="bi bi-chat-fill"></i> -->
        <img src="../../assets/imgs/admin-new-new.png" alt="admin" width="30" class="rounded-cirlce" />
      </button>

      <b-popover id="custom-popover-content" target="counseling-button" triggers="hover" placement="top"
        class="bg-dark">
        <div class="d-flex align-items-center">
          <!-- <h4>Book Free Counselling</h4> -->
          <div class="text-new p-3 text-start text-light">
            <h2 class="font-weight-bold">Hi there!</h2>
            <p class="">We Are here to Help!</p>
            <button class="pop-btn rounded-pill">Book Free Counselling</button>
          </div>
        </div>
      </b-popover>

      <b-modal id="book-counselling-call-modal-id" ref="book-counselling-call-modal-ref" centered cancel-disabled
        ok-disabled :hide-footer="true">
        <div slot="modal-title">
          <img title="my-img" src="@/assets/imgs/student-enquiry-form/AliffLogo.png" alt="people"
            class="free-counselling-logo" />
          Book Free Counselling
        </div>
        <div>
          Go doubt-free in your study abroad journey by connecting with our
          experts!
        </div>
        <div class="mt-3">Schedule a free call and get:</div>
        <ul>
          <li>Your profile evaluated.</li>
          <li>Country, university and course guidance.</li>
          <li>Scholarship and loan assistance.</li>
        </ul>
        <button class="btn-secondary-red mt-4 w-100" v-b-modal.book-counselling-modal-id>
          Schedule Call
        </button>
      </b-modal>

      <b-modal id="book-counselling-modal-id" ref="book-counselling-modal-ref" centered title="Book Free Counselling"
        cancel-disabled ok-disabled :hide-footer="true">
        <vue-calendly :height="600" url="https://calendly.com/info-aliff-39025">
        </vue-calendly>
      </b-modal>
    </div>

    <!-- <FixedVideoBox v-if="showFixedVideoBox" /> -->
  </div>
</template>

<script>
import homeServices from "@/apiServices/homeServices";
import { mapGetters, mapActions } from "vuex";
// import stateCity from "../partials/stateCity";
// import { DASHBOARD_REGISTER_URL, DASHBOARD_LOGIN_URL } from "@/config";
import axios from "axios";
export default {
  name: "Header",
  data() {
    return {
      DASHBOARD_REGISTER_URL: "https://app.aliff.in/",
      DASHBOARD_LOGIN_URL: "https://app.aliff.in/",
      countries: [],
      services: [],
      servicesRoutes: [
        "/abroad-counselling",
        "/career-counselling",
        "/edgeout",
        "/ielts",
        "/aliff-premium",
      ], // harcoded
      cityOptions: [],
      form: {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
        messageData: "",
      },
      WhoAreU: "",
      showFixedVideoBox: false,
    };
  },
  computed: {
    ...mapGetters(["getCountries", "getBlogs"]),
  },
  components: {
    FixedVideoBox: () => import('./FixedVideoBox.vue'),
  },
  methods: {
    ...mapActions(["onGetCountries"]),
    redirectTo(to) {
      window.location.href = to;
    },
    onSelectIam(val) {
      // if (["Student", "Parent"].includes(val)) {
      //   this.mail_to = "info@aliff.in";
      // } else {
      //   this.mail_to = "jenny@aliff.in";
      // }
      this.WhoAreU = val;
    },
    // stateOptions() {
    //   return stateCity.map((stateCity) => stateCity.state);
    // },
    // geCityOptions() {
    //   let currentStateCity = stateCity.find(
    //     (stateCity) => stateCity.state === this.form.state
    //   );

    //   this.cityOptions = currentStateCity.cities;
    // },
    formSubmitToast() {
      this.$bvToast.toast(`The form has been submitted successfully.`, {
        title: "Form Submitted",
        autoHideDelay: 5000,
        solid: true,
      });
    },
    // checkScroll() {
    //   const heroSection = document.getElementById('hero-section');
    //   if (
    //     document.body.scrollTop > 200 ||
    //     document.documentElement.scrollTop > 200
    //   ) { this.showFixedVideoBox = true }
    // },

    async handleSubmit(e) {
      // let formData = {};

      // Array.from(this.$refs.form.elements).forEach((element) => {
      //   console.log({ element });
      //   if (element.type !== "submit" && element.type !== "file") {
      //     formData[element.name] = element.value;
      //   }
      // });
      try {
        e.preventDefault();
        // this.messageData = document.getElementById("message_id").value;
        const formData = {
          Name: this.form.name,
          Email: this.form.email,
          dial_code_id: "12183",
          country_dial_code: "+91",
          ContactNumber: this.form.mobileNumber,
          source: "feedback-form",
          WhoAreU: this.WhoAreU,
          // state: this.form.state,
          // city: this.form.city,
          messageData: this.form.messageData,
        };

        // const response = await axios.post(
        //   "https://formsubmit.co/ajax/fahadchowdhary007@gmail.com",
        //   requestData
        // );
        // console.log(response, "response");

        // axios.defaults.headers.post["Content-Type"] = "application/json";
        // axios
        //   .post(
        //     "https://formsubmit.co/ajax/fahadchowdhary007@gmail.com",
        //     requestData
        //   )
        //   .then((response) => console.log(response))
        //   .catch((error) => console.log(error));
        const response = await homeServices.sendFeedbackFormMail({
          formData,
        });

        if (response.data.status) {
          this.resetForm();
          this.formSubmitToast();
          this.$bvModal.hide("feedback-form-call-modal-id");
        }

        console.log("API Response:", response.data);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },

    resetForm() {
      this.form = {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
      };
    },
  },

  beforeMount() {
    this.onGetCountries();
    // window.addEventListener('scroll', this.checkScroll);

  },
};
window.onscroll = function () {
  scrollFunction();
  // checkScroll()
};

function scrollFunction() {
  const element = document.querySelector(".custom-header");
  if (
    document.body.scrollTop > 50 ||
    document.documentElement.scrollTop > 50
  ) {
    element.classList.add("scrolled");
  } else {
    element.classList.remove("scrolled");
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

.text-new,
h2 {
  font-family: "Poppins", serif !important;
}

.simple-dropdown-menu .dropdown-item:hover {
  color: #00d09c;
}

.popover-body {
  background-color: black;
  border-radius: 15px !important;
}

.popover {
  border-radius: 15px !important;
}

button.pop-btn {
  background-color: transparent;
  border: 1px solid #fff;
  color: #fff;
  padding: 4px 15px;
  transition: 0.3s;
}

button.pop-btn:hover {
  background-color: #fff;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Header.vue